import { useUpdateQuoteStatus } from "@/common/api/mutation";
import {
  quoteStatuses,
  QuoteStatusesType,
} from "@/common/const/quote/quoteStatuses.const";
import { usePermissions } from "@/common/contexts/Permissions.context";
import { cn, queryClient } from "@/common/utils";
import { Select } from "antd";
import { toast } from "react-toastify";

interface AIRXQuoteStatusCellProps {
  value: QuoteStatusesType;
  permission: string;
  quoteId: number;
}

export default function AIRXQuoteStatusCell({
  value,
  quoteId,
  permission
}: AIRXQuoteStatusCellProps) {
  const {isHavePermission} = usePermissions()
  const { mutate } = useUpdateQuoteStatus();
  const style = () => {
    switch (value) {
      case "Expired":
        return "text-red-light bg-red-main";
      case "Loss":
        return "text-purple-main bg-purple-light";
      case "Quoted":
        return "text-primary bg-primaryDim";
      case "NoBid":
        return "bg-gray-border text-gray-dim";
      case "Pending":
        return "bg-yellow-main text-yellow-secondary";
      case "Won":
        return "bg-success-light text-success-dark";
      default:
        return "";
    }
  };
  return (
    <>
      <Select
        variant="filled"
        disabled={!isHavePermission(permission)}
        defaultValue={value}
        options={quoteStatuses.slice(0, -1)}
        popupMatchSelectWidth={false}
        onChange={(opt) => {
          mutate(
            { quoteId: quoteId.toString(), quoteStatus: opt },
            {
              onSuccess: () => {
                toast.success("Quote status changed");
                queryClient.invalidateQueries();
              },
            }
          );
        }}
        popupClassName=""
        className={cn(
          "font-light text-base font-kanit border-none rounded-full transition text-red-main",
          style()
        )}
      />
    </>
  );
}
